import React from 'react';
import ReactMarkdown from 'react-markdown';
import './style.css';

const Markdown = ({
  markdown,
  nOfLines,
  style,
}: {
  markdown: string;
  nOfLines?: number;
  style?: React.CSSProperties;
}) => {
  return (
    <div
      style={{
        ...style,
        ...(nOfLines
          ? {
              WebkitLineClamp: nOfLines,
              WebkitBoxOrient: 'vertical',
              display: '-webkit-box',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }
          : {}),
      }}
    >
      <ReactMarkdown className="markdown-content">{markdown}</ReactMarkdown>
    </div>
  );
};

export default Markdown;
